
export const initConfig = {
    height: 300,
    menubar: false,
    plugins: [],
    toolbar: 'bold italic underline ',

}